module.exports = __webpack_public_path__ + "static/media/freedom.e9a8913c.svg";